import * as Audio from './Audio.js'

export const Commands = {
  'Audio.play': Audio.play,
}
